// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {routerActions} from 'react-router-redux';

export const setRouteToReturnPartAttachmentTab = () =>
        dispatch => {

            dispatch(routerActions.push('/rga/recalled/returned-part?tab=attachment'));

        };

export const updateFilterBy = filterText => ({
    data: filterText,
    type: actions.UPDATE_RGA_SEARCH_LIST_FILTER_BY
});

export const updateSortBy = option => ({
    data: option,
    type: actions.UPDATE_RGA_SEARCH_LIST_SORT_BY
});

export const updateSortDirection = direction => ({
    data: direction,
    type: actions.UPDATE_RGA_SEARCH_LIST_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/action-creators/search-filters.js